<template>
    <pm-app-component hide-sidebar barColor="#8dc243" :backBtnCb="backBtnCb">

        <template slot="mobile-toolbar">
            <pm-application-bar>
                {{ $t('photos.title') }}
            </pm-application-bar>
            <mdi class="white--text" @click.native="toggleGrid" :key="grid" v-if="$IAP.hasAccessToComponent('photos')">
                <template v-if="grid===4">checkerboard</template>
                <template v-else-if="grid===3">grid</template>
                <template v-else-if="grid===2">grid-large</template>
                <template v-else>view-agenda-outline</template>
            </mdi>
        </template>

        <div id="main-container" class="app-content-container" style="padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);" :class="['pm-gallery-grid-'+grid]">
            <div style="position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; box-shadow: 0 -8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03); display: flex; flex-direction: column;"
                 :class="$theme.contentBg"
            >
                <div class="pm-gallery-breadcrumbs" v-if="currentView === 'before-after'">
                    <mdi size="18" style="margin: 0 5px 0px 0;">emoticon-happy-outline</mdi> {{ $t('photos.before_after') }}
                </div>
                <div class="pm-gallery-breadcrumbs" v-else-if="currentView === 'favourites'">
                    <mdi size="18" style="margin: 0 5px 0px 0;">heart-outline</mdi> {{ $t('photos.favourites') }}
                </div>

                <div class="pm-gallery-breadcrumbs" v-else-if="currentView === 'gallery'">
                    <mdi size="18" style="margin: 0 5px 0px 0;">heart-outline</mdi> {{ $t('photos.favourites') }}
                </div>

                <div class="pm-gallery-breadcrumbs" v-else>
                    <mdi size="18" style="margin: 0 5px 0px 0;">image-outline</mdi>
                    {{ $t('photos.title') }}
                </div>

                <slot name="default"></slot>

            </div>
        </div>

        <!-- <pm-welcome-screen v-if="onboarding.length > 0" :steps="onboarding" /> -->
    </pm-app-component>
</template>

<style>
    .pm-gallery-breadcrumbs {
        position: relative;
        border-bottom: 1px solid #f6f6f6;
        text-align: center;
        padding: 10px 15px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .08);
        background: #f1f1f1;
        color: #000;
    }
</style>

<script>
import { onboarding } from "./onboarding.js";

const defaultGrid = 2;

export default {
    data: () => ({
        grid: defaultGrid,
        firstRun: false,
    }),

    props: {
        currentView: {
            type: String,
            default: "all",
        }
    },

    created() {
        this.setGrid();
        this.onboarding = onboarding();
    },

    methods: {
        backBtnCb() {
            if (this.currentView === 'gallery') this.$emit('changeView', 'all');
            else this.$router.push('/');
        },
        toggleGrid() {
            this.grid--;
            if (this.grid === 0) this.grid = 4;
            localStorage.setItem('galleryGrid', this.grid);
            this.$bus.$emit('galleryGridToggled');
        },
        setGrid() {
            try {
                if (!this.$store.state.isPro) return; // Grid changing is allowed only for paid users
                if (localStorage.getItem('galleryGrid')) this.grid = parseInt(localStorage.getItem('galleryGrid'));
                else localStorage.setItem('galleryGrid', this.grid);
            } catch(error) {
                captureException(error);
            }
        },
    },
}
</script>
